export const adminRoutes = [
    {
        path: '/admin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./admin'));
            reject(error);
        }),
    },

    {
        path: '/siteadmin/content-management',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/blogManagement'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/page/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/addBlogDetails'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/edit/page/:blogId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/editBlogDetails'));
            reject(error);
        }),
    },

    {
        path: '/siteadmin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/adminDashboard'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/change/admin',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/changeAdmin'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/users',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/users'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/site',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/siteSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/config',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/siteConfiguration'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/listsettings/:typeId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/listSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/listings',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/listings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/listing-priorities',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/listingPriorities'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/listingApproval',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/listingPermission'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/currency',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/currencies'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/search',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/searchSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/home/caption',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/bannerSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/home/banner',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/imageBanner'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/reservations',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/reservations'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/receipt/:reservationId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/viewReceipt'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/settings/servicefees',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/serviceFeesSettings'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/reviews',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/adminReviews'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/write-reviews',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/writeReview'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/reviews/edit-review/:reviewId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/editReview'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/viewreservation/:id/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/viewreservation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/home/footer-block',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/footerBlock'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/messages',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/messages'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/reportUser',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/reportUser'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/popularlocation',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/popularLocation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/edit/popularlocation/:locationId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/editPopularLocation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/popularlocation/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/addPopularLocation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/staticpage/management',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/staticPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/edit/staticpage/:pageId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/editStaticPage'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/home/static-info-block',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/staticBlock'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/home/home-banner',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/homeBanner'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/viewpayout/:id/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/viewPayout'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/viewrefund/:id/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/viewRefund'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/profile-view/:profileId?',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/profileView'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/document',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/document'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/user-reviews',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/userReviews'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/management-reviews/:reviewId',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/userEditReviews'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/admin-roles',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/adminRoles'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/admin-users',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/adminUser'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/Block1',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/whyHostBlock1'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/review',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/adminReviews'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/review/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/editReviews'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/review/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/addReviews'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/Block3',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/whyHostBlock3'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/Block4',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/whyHostBlock4'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/Block2',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/whyHostBlock2'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/Block6',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/whyHostBlock6'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/whyHost/Block7',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHostPageSettings/whyHostBlock7'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/payout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/payoutManagement'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/refund',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/refundManagement'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/listing-request',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/listingPermission'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/why-host',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/whyHost'));
            reject(error);
        }),
    },

    {
        path: '/siteadmin/payment-gateway-section',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/paymentGateway'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancellation-policies/management',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/cancellationPolicies'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/login',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/adminLogin'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancellation-policies/edit/:id?',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/cancellationPolicies/editCancelPolicy'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/viewInquiry/:id/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/viewInquiry'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/inquiry',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/Inquiry'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/cancel/:reservationId/:userType',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/cancellation'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/edit-profile/:profileId?',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/editProfile'));
            reject(error);
        }),
    },

    {
        path: '/siteadmin/smtp-info',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/smtpInfo'));
            reject(error);
        }),
    },
    {
        path: '/siteadmin/calendar',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./siteadmin/calendar'));
            reject(error);
        }),
    },
];